import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconCheckoutStyle0 = cosmosIconCss;

const CosmosIconCheckout$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCheckout extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'fb4136aa713c22ad1db70b837b6232755670ac88', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '5b173877979de4ef766e0d6017614f3b83ad958e', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'ed767b221effe95a3837e677ab8524f6e329cf2f', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 2a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9Zm0 1.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Zm1.156 4.302a.377.377 0 0 1 .425.073l2.824 2.861c.14.152.14.385 0 .537l-2.824 2.824a.377.377 0 0 1-.64-.274v-2.089H6.765a.47.47 0 0 1-.47-.47v-.471c0-.26.21-.47.47-.47h5.176V8.175a.376.376 0 0 1 .215-.374Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconCheckoutStyle0; }
}, [1, "cosmos-icon-checkout", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-checkout"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-checkout":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCheckout$1);
            }
            break;
    } });
}

const CosmosIconCheckout = CosmosIconCheckout$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCheckout, defineCustomElement };
